import React from "react";

import {
  Card,
  CardBody,
  Row,
  Col,
  Input,
} from "reactstrap";

const MenuHeader = ({

  search,
  setSearch,

  orderType,
  setOrderType,

  selectedRoom,
  setSelectedRoom,

  rooms,

  foodType,
  setFoodType,

  categories,

  selectedCategory,
  setSelectedCategory,

}) => {

  return (

    <Card
      style={{
        borderRadius: 8,
        boxShadow: "none",
      }}
    >

      <CardBody>


        {/* ======================
            TOP FILTERS
        ====================== */}

        <Row className="align-items-center mb-3 g-2">


          {/* SEARCH */}

          <Col md={3}>

            <Input
              placeholder="Search food..."
              value={search}
              onChange={(e) =>
                setSearch(
                  e.target.value
                )
              }
            />

          </Col>


          {/* ORDER TYPE */}

          <Col md={3}>

            <div
              style={{
                background: "#f3f3f3",
                borderRadius: 6,
                display: "flex",
                overflow: "hidden",
              }}
            >

              <div
                onClick={() =>
                  setOrderType(
                    "DINE_IN"
                  )
                }
                style={{
                  flex: 1,
                  padding: "8px",
                  textAlign: "center",
                  cursor: "pointer",

                  background:

                    orderType === "DINE_IN"

                      ? "#687cfe"

                      : "transparent",

                  color:

                    orderType === "DINE_IN"

                      ? "#fff"

                      : "#666",

                  fontWeight: 600,
                }}
              >

                Dine In

              </div>


              <div
                onClick={() =>
                  setOrderType(
                    "ROOM_DELIVERY"
                  )
                }
                style={{
                  flex: 1,
                  padding: "8px",
                  textAlign: "center",
                  cursor: "pointer",

                  background:

                    orderType ===
                    "ROOM_DELIVERY"

                      ? "#687cfe"

                      : "transparent",

                  color:

                    orderType ===
                    "ROOM_DELIVERY"

                      ? "#fff"

                      : "#666",

                  fontWeight: 600,
                }}
              >

                Room

              </div>

            </div>

          </Col>


          {/* ROOM */}

          <Col md={3}>

            <Input
              type="select"
              value={selectedRoom}
              onChange={(e) =>
                setSelectedRoom(
                  e.target.value
                )
              }
            >

              <option value="">
                Select Room
              </option>

              <option value="Others">
                Others
              </option>


              {rooms.map(
                (room) => (

                  <option
                    key={room._id}
                    value={
                      room.roomNumber
                    }
                  >

                    {room.roomNumber}

                    {" - "}

                    {
                      room.roomType
                        ?.name
                    }

                  </option>

                )
              )}

            </Input>

          </Col>


          {/* FOOD TYPE */}

          <Col md={3}>

            <div
              style={{
                background: "#f3f3f3",
                borderRadius: 6,
                display: "flex",
                overflow: "hidden",
              }}
            >

              <div
                onClick={() =>
                  setFoodType(
                    "Veg"
                  )
                }
                style={{
                  flex: 1,
                  padding: "8px",
                  textAlign: "center",
                  cursor: "pointer",

                  background:

                    foodType === "Veg"

                      ? "#22c55e"

                      : "transparent",

                  color:

                    foodType === "Veg"

                      ? "#fff"

                      : "#666",

                  fontWeight: 600,
                }}
              >

                Veg

              </div>


              <div
                onClick={() =>
                  setFoodType(
                    "Non Veg"
                  )
                }
                style={{
                  flex: 1,
                  padding: "8px",
                  textAlign: "center",
                  cursor: "pointer",

                  background:

                    foodType ===
                    "Non Veg"

                      ? "#ef4444"

                      : "transparent",

                  color:

                    foodType ===
                    "Non Veg"

                      ? "#fff"

                      : "#666",

                  fontWeight: 600,
                }}
              >

                Non Veg

              </div>

            </div>

          </Col>

        </Row>


        <hr />


        {/* ======================
            CATEGORY
        ====================== */}

        <h6
          style={{
            fontWeight: 700,
            marginBottom: 15,
          }}
        >

          Select Category

        </h6>


        <div
          className="
            d-flex
            gap-2
            flex-wrap
            mb-2
          "
        >


          {/* ALL */}

          <div

            onClick={() =>
              setSelectedCategory(
                "ALL"
              )
            }

            style={{
              padding: "8px 20px",
              borderRadius: 6,

              background:

                selectedCategory ===
                "ALL"

                  ? "#687cfe"

                  : "#f2f2f2",

              color:

                selectedCategory ===
                "ALL"

                  ? "#fff"

                  : "#000",

              cursor: "pointer",

              fontWeight: 600,

              height: 35,
            }}

          >

            All

          </div>


          {/* CATEGORIES */}

          {categories.map(
            (cat) => (

              <div

                key={cat._id}

                onClick={() =>
                  setSelectedCategory(
                    cat.name
                  )
                }

                style={{
                  padding:
                    "8px 20px",

                  borderRadius: 6,

                  background:

                    selectedCategory ===
                    cat.name

                      ? "#687cfe"

                      : "#f2f2f2",

                  color:

                    selectedCategory ===
                    cat.name

                      ? "#fff"

                      : "#000",

                  cursor: "pointer",

                  fontWeight: 600,

                  height: 35,
                }}

              >

                {cat.name}

              </div>

            )
          )}

        </div>

      </CardBody>

    </Card>

  );

};

export default MenuHeader;